import { render, staticRenderFns } from "./drawerTask.vue?vue&type=template&id=006a4416&"
import script from "./drawerTask.vue?vue&type=script&lang=js&"
export * from "./drawerTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports